const statesList = [
    { code: "AN", name: "Andaman and Nicobar Islands" },
    { code: "AP", name: "Andhra Pradesh" },
    { code: "AR", name: "Arunachal Pradesh" },
    { code: "AS", name: "Assam" },
    { code: "BH", name: "Bihar" },
    { code: "CH", name: "Chandigarh" },
    { code: "CG", name: "Chhattisgarh" },
    { code: "DN", name: "Dadra and Nagar Haveli" },
    { code: "DD", name: "Daman and Diu" },
    { code: "ND", name: "Delhi" },
    { code: "GO", name: "Goa" },
    { code: "GU", name: "Gujarat" },
    { code: "HA", name: "Haryana" },
    { code: "HP", name: "Himachal Pradesh" },
    { code: "KR", name: "Jammu and Kashmir" },
    { code: "JD", name: "Jharkhand" },
    { code: "KA", name: "Karnataka" },
    { code: "KE", name: "Kerala" },
    { code: "LD", name: "Lakshadweep" },
    { code: "MP", name: "Madhya Pradesh" },
    { code: "MA", name: "Maharashtra" },
    { code: "MN", name: "Manipur" },
    { code: "ME", name: "Meghalaya" },
    { code: "MI", name: "Mizoram" },
    { code: "NA", name: "Nagaland" },
    { code: "OD", name: "ODISHA" },
    { code: "PO", name: "Puducherry" },
    { code: "PU", name: "Punjab" },
    { code: "RA", name: "Rajasthan" },
    { code: "SI", name: "Sikkim" },
    { code: "TN", name: "Tamil Nadu" },
    { code: "TE", name: "Telangana" },
    { code: "TR", name: "Tripura" },
    { code: "UP", name: "Uttar Pradesh" },
    { code: "UR", name: "Uttarakhand" },
    { code: "WB", name: "West Bengal" }
  ];
export default statesList;  